<template>
	<inertia-head title="Members" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">View Members Profile</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-12">
									<div class="mb-4">
										<label for="date" class="form-label">
											Registration Date
										</label>
										<flat-pickr
											v-model="form.date"
											id="date"
											class="form-control form-control-sm"
											:config="{
												altInput: true,
												altFormat: 'M j, Y',
												dateFormat: 'Y-m-d',
												wrap: true,
												mode: 'range',
											}"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-3">
									<div class="mb-4">
										<label for="filterByColumn" class="form-label">Filter by</label>
										<select name="filterByColumn"
											v-model="form.filterByColumn"
											class="form-select form-select-sm"
										>
											<option value="lifetime">Lifetime</option>
											<option value="username">Email</option>
											<option value="fname">First Name</option>
											<option value="lname">Last Name</option>
											<option value="current_rank">Membership Level</option>
											<option value="counter">User ID</option>
											<option value="mobile">Mobile Number</option>
										</select>
									</div>
								</div>
								<div class="col-md-3">
									<div class="mb-4">
										<label for="columnValue" class="form-label">Value</label>
										<input
											name="columnValue"
											v-model="form.columnValue"
											type="text"
											class="form-control form-control-sm"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="mb-4">
										<label for="status" class="form-label">Status</label>
										<select v-model="form.status" id="status" name="status" class="form-select form-select-sm">
											<option value="">ALL</option>
											<option value="1">Active</option>
											<option value="0">Expired</option>
										</select>
									</div>
								</div>
								<div class="col-md-3">
									<div class="mb-4 pt-4">
										<button
											type="submit"
											class="btn btn-alt-primary"
											:disabled="form.processing"
										>
											<div
												v-if="form.processing"
												class="spinner-border spinner-border-sm text-dark"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
											<span v-else>
												<i class="fa fa-search me-1"></i>
											</span>
											Search
										</button>
										<button
											@click="
												$inertia.get(route('admin.user-management.members.index'))
											"
											type="button"
											class="btn btn-alt-secondary"
										>
											Reset
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead class="text-center">
							<tr>
								<th>#</th>
								<th>USERID</th>
								<th>MEMBERSHIP</th>
								<th>EXPIRY</th>
								<th>FULLNAME</th>
								<th>EMAIL</th>
								<th>DATE REGS</th>
							</tr>
						</thead>
						<tbody v-if="members.data.length > 0" class="fs-sm">
							<tr
								v-for="(member, index) in members.data"
								:key="member.counter"
								class="text-center"
							>
								<td>{{ index + members.from }}</td>
								<td>
									<inertia-link
										:href="
											route(
												'admin.user-management.members.show',
												member.member_uuid
											)
										"
										class="fw-semibold text-info"
									>
										{{ member.counter }}
										<i class="fa fa-arrow-right"></i>
									</inertia-link>
								</td>
								<td data-title="Membership:">{{ member.rank_format }}</td>
								<td data-title="Expiry:">
									<h6 class="fw-semibold fs-xs mb-0">{{ member.expiry }}</h6>
									<small
										:class="
											member.daysRemaining > 7 ? 'text-success' : 'text-danger'
										"
									>
										{{
											member.daysRemaining <= 0
												? 'Expired'
												: `${member.daysRemaining} ${member.daysRemainingStr} remaining`
										}}
									</small>
								</td>
								<td data-title="Fullname:">
									{{ member.full_name }}
									<div><sub class="text-elegance">Mobile#:{{member.mobile}}</sub></div>
								</td>
								<td data-title="Email:">{{ member.email }}</td>
								<td data-title="Date regs:">
									<h6 class="mb-0 fs-xs">{{ member.dateregs }}</h6>
									<small>{{ member.timeregs }}</small>
								</td>
							</tr>
						</tbody>
						<tbody v-else class="fs-sm">
							<tr>
								<th colspan="7" class="text-center">NO RECORD FOUND</th>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="members" />
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		members: Object,
		filters: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			date: props.filters.date,
			filterByColumn: props.filters.filterByColumn?props.filters.filterByColumn:'username',
			columnValue: props.filters.columnValue,
			status: props.filters.status?props.filters.status:'',
		})

		const toggleShowExpired = () => {
			form.showExpired = form.showExpired ? false : true
		}

		const submit = () => {
			form.get(route('admin.user-management.members.index'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		return {
			form,
			submit,
			toggleShowExpired,
		}
	},
}
</script>
